import { DataType } from "@cloudpivot/form/typings";
import { styleControlOptions } from "@cloudpivot/form/component-schema";
export default {
    $id: "formTitle",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {},
};
